import {create} from 'zustand';
import {Lead, TradeInEvaluation} from '../types/salesforce';
import {QuestionThirteenForm} from '../types/surveyResponse';
import {SalesforceSurvey, SalesforceSurveySchema} from '../questions/schema';
import {config} from '../environment';

interface SalesForceObjectStore {
  questionThirteenForm: QuestionThirteenForm;
  setQuestionThirteenForm: (questionThirteenForm: QuestionThirteenForm) => void;
  lead: Lead;
  setLead: (lead: Lead) => void;
  tradeInEvaluation: TradeInEvaluation;
  setTradeInEvaluation: (tradeInEvaluation: TradeInEvaluation) => void;
}

export const useSalesForceObjectStore = create<SalesForceObjectStore>(
  (set) => ({
    questionThirteenForm: {} as QuestionThirteenForm,
    setQuestionThirteenForm: (questionThirteenForm: QuestionThirteenForm) => {
      set(() => {
        return {
          questionThirteenForm: questionThirteenForm,
        };
      });
    },
    lead: {} as Lead,
    setLead: (lead: Lead) => {
      set(() => {
        return {
          lead,
        };
      });
    },
    tradeInEvaluation: {} as TradeInEvaluation,
    setTradeInEvaluation: (tradeInEvaluation: TradeInEvaluation) => {
      set(() => {
        return {
          tradeInEvaluation,
        };
      });
    },
  }),
);

export async function sendSaleForceSurvey(payload: SalesforceSurvey) {
  const result = SalesforceSurveySchema.safeParse(payload);
  if (!result.success) {
    console.log(result.error);
    return;
  }

  const res = await fetch(`${config.API_SALESFORCE_SURVEY_URL}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(result.data),
  });
  return res.json();
}
